"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStudentsPickupLocationsController = /** @class */ (function () {
    function AdminStudentsPickupLocationsController(UsersModel, ReportsModel, LocationsModel, SchoolsModel, UserService, $timeout, $scope) {
        var _this = this;
        this.UsersModel = UsersModel;
        this.ReportsModel = ReportsModel;
        this.LocationsModel = LocationsModel;
        this.SchoolsModel = SchoolsModel;
        this.UserService = UserService;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.studentName = null;
        this.submitting = false;
        this.location = null;
        this.sector = null;
        // Initialize map properties
        this.mapData = null;
        this.mapCenter = null;
        this.mapLocations = [];
        this.mapMarkers = [];
        this.mapGeojson = null;
        this.school = null;
        this.loading = true;
        this.showHomeAddress = true;
        this.showPickupLocations = true;
        this.pickuplocations = [];
        this.stats = {
            students: 0,
            locations: 0,
        };
        this.filterOptions = [
            { name: "All" },
            { name: "Inactive" },
            { name: "Unverified" },
            { name: "Active" },
            { name: "Unpaid Fees" },
            { name: "Archived" },
        ];
        // Get current user for school_id
        this.currentUser = UserService.getCurrentUser();
        this.status = { name: "Active" };
        this.getSearchParams = this.getSearchParams.bind(this);
        this.processStudents = this.processStudents.bind(this);
        this.loadPickupLocationsData = this.loadPickupLocationsData.bind(this);
        this.transformMapData = this.transformMapData.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        // Build the filter options
        LocationsModel.getLocations().then(function (response) {
            _this.locations = response;
            _this.locations.unshift({ name: "All" });
            _this.sectors = response.map(function (location) { return location.zoneparts; }).flat();
            _this.sectors.unshift({ name: "All" });
        });
        SchoolsModel.getSchoolByID(this.currentUser.school.id).then(function (response) {
            _this.school = response;
            _this.mapLocations = _this.school.locations;
            _this.mapCenter = {
                lat: _this.school.locations[0].address.lat,
                lng: _this.school.locations[0].address.lng,
                zoom: 12,
            };
            _this.loading = false;
        });
        // Load pickup locations data
        this.loadPickupLocationsData();
    }
    AdminStudentsPickupLocationsController.prototype.processStudents = function (student) {
        if (student.default_school_location.length !== 0) {
            student.location = student.default_school_location[0].name;
        }
        if (student.default_sector.length !== 0) {
            student.zone = student.default_sector[0].name;
        }
        var params = this.getSearchParams(false);
        if (params.sector !== null && this.sector) {
            student.zone = this.sector.name;
        }
        return student;
    };
    AdminStudentsPickupLocationsController.prototype.getSearchParams = function (getStats) {
        if (getStats === void 0) { getStats = false; }
        var params = {
            name: this.studentName,
            location: !this.location ? null : this.location.id,
            sector: !this.sector ? null : this.sector.id,
            status: !this.status ? null : this.status.name,
            withStats: getStats,
        };
        // Filter out null values
        return Object.fromEntries(Object.entries(params).filter(function (_a) {
            var key = _a[0], value = _a[1];
            return value !== null;
        }));
    };
    AdminStudentsPickupLocationsController.prototype.loadPickupLocationsData = function () {
        var _this = this;
        // Get school_id from current user
        var school_id = this.currentUser.school.id;
        var params = this.getSearchParams(true);
        this.SchoolsModel.getPickupLocations(school_id, params)
            .then(function (response) {
            _this.transformMapData(response);
        })
            .catch(function (Error) {
            console.error("Error fetching pickup locations");
            console.error(Error);
        });
    };
    AdminStudentsPickupLocationsController.prototype.transformMapData = function (data) {
        var _this = this;
        console.log("Transforming Map Data");
        // Defensive check for data integrity
        if (!data || !data.students) {
            console.error("No data or students found");
            this.pickuplocations = [];
            this.mapMarkers = [];
            this.stats.students = 0;
            this.stats.locations = 0;
            return;
        }
        this.pickuplocations = data.students
            .flatMap(function (student) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var lat = (_b = (_a = student.usermeta) === null || _a === void 0 ? void 0 : _a.find(function (meta) { return meta.meta_key === "home_address"; })) === null || _b === void 0 ? void 0 : _b.meta_value.lat;
            var lng = (_d = (_c = student.usermeta) === null || _c === void 0 ? void 0 : _c.find(function (meta) { return meta.meta_key === "home_address"; })) === null || _d === void 0 ? void 0 : _d.meta_value.lng;
            // Validate coordinates
            var numLat = Number(lat);
            var numLng = Number(lng);
            var hasValidCoords = !isNaN(numLat) &&
                !isNaN(numLng) &&
                numLat !== 0 &&
                numLng !== 0 &&
                Math.abs(numLat) <= 90 &&
                Math.abs(numLng) <= 180;
            var homeAddress = {
                lat: numLat,
                lng: numLng,
                name: student.firstname + " " + student.lastname + " Home Address",
                address: {
                    street: (_f = (_e = student.usermeta) === null || _e === void 0 ? void 0 : _e.find(function (meta) { return meta.meta_key === "home_address"; })) === null || _f === void 0 ? void 0 : _f.meta_value.street,
                    city: (_h = (_g = student.usermeta) === null || _g === void 0 ? void 0 : _g.find(function (meta) { return meta.meta_key === "home_address"; })) === null || _h === void 0 ? void 0 : _h.meta_value.city,
                    state: (_k = (_j = student.usermeta) === null || _j === void 0 ? void 0 : _j.find(function (meta) { return meta.meta_key === "home_address"; })) === null || _k === void 0 ? void 0 : _k.meta_value.state,
                    zip: (_m = (_l = student.usermeta) === null || _l === void 0 ? void 0 : _l.find(function (meta) { return meta.meta_key === "home_address"; })) === null || _m === void 0 ? void 0 : _m.meta_value.zip,
                },
                user_id: student.id,
                zones: [],
                zoneparts: [],
                isValid: hasValidCoords,
                isHomeAddress: true,
            };
            var pickuplocations = student.pickuplocations.map(function (data) {
                data.isHomeAddress = false;
                return data;
            });
            return __spreadArray(__spreadArray([], pickuplocations, true), [homeAddress], false);
        })
            .map(function (location) {
            // Strategy 1: Root level coordinates
            var lat = location.lat;
            var lng = location.lng;
            // Validate coordinates
            var numLat = Number(lat);
            var numLng = Number(lng);
            var hasValidCoords = !isNaN(numLat) &&
                !isNaN(numLng) &&
                numLat !== 0 &&
                numLng !== 0 &&
                Math.abs(numLat) <= 90 &&
                Math.abs(numLng) <= 180;
            return {
                lat: numLat,
                lng: numLng,
                name: location.name,
                address: {
                    street: location.address.street,
                    city: location.address.city,
                    state: location.address.state,
                    zip: location.address.zip,
                    lat: numLat,
                    lng: numLng,
                },
                popupData: _this.formatLocationPopup(location),
                user_id: location.user_id,
                zones: location.zones,
                zoneparts: location.zoneparts,
                isValid: hasValidCoords,
                isHomeAddress: location.isHomeAddress,
            };
        });
        // Filter and count results
        var validMarkers = this.pickuplocations.filter(function (marker) { return marker.isValid; });
        var invalidMarkers = this.pickuplocations.filter(function (marker) { return !marker.isValid; });
        if (invalidMarkers.length > 0) {
            console.warn("Invalid markers:", invalidMarkers.map(function (m) { return ({ name: m.name, lat: m.lat, lng: m.lng }); }));
        }
        this.mapMarkers = validMarkers;
        var students = data.students;
        this.students = students;
        this.stats.students = students.length;
        this.stats.locations = validMarkers.length;
    };
    AdminStudentsPickupLocationsController.prototype.formatLocationPopup = function (location) {
        var html = "<strong>".concat(location.name, "</strong><br/>");
        html += "".concat(location.address.street, "<br/>");
        html += "".concat(location.address.city, ", ").concat(location.address.state, " ").concat(location.address.zip, "<br/>");
        if (location.zones && location.zones.length > 0) {
            html += "<strong>Zones:</strong> ".concat(location.zones.map(function (z) { return z.name; }).join(", "), "<br/>");
        }
        if (location.zoneparts && location.zoneparts.length > 0) {
            html += "<strong>Sectors:</strong> ".concat(location.zoneparts.map(function (z) { return z.name; }).join(", "));
        }
        return html;
    };
    AdminStudentsPickupLocationsController.prototype.applyFilter = function () {
        this.submitting = true;
        this.loadPickupLocationsData();
        this.submitting = false;
    };
    AdminStudentsPickupLocationsController.prototype.toggleHomeAddress = function () {
        var _this = this;
        this.mapMarkers = this.pickuplocations.filter(function (marker) {
            if (marker.isHomeAddress) {
                return _this.showHomeAddress && marker.isValid;
            }
            return _this.showPickupLocations && marker.isValid;
        });
    };
    AdminStudentsPickupLocationsController.prototype.togglePickupLocations = function () {
        var _this = this;
        this.mapMarkers = this.pickuplocations.filter(function (marker) {
            if (marker.isHomeAddress) {
                return _this.showHomeAddress && marker.isValid;
            }
            return _this.showPickupLocations && marker.isValid;
        });
    };
    return AdminStudentsPickupLocationsController;
}());
AdminStudentsPickupLocationsController.$inject = [
    "UsersModel",
    "ReportsModel",
    "LocationsModel",
    "SchoolsModel",
    "UserService",
    "$timeout",
    "$scope",
];
exports.default = AdminStudentsPickupLocationsController;
